export const namespaced = true;

export const state = {
  blockingLoader: false,
  nonBlockingLoader: false,
  tableLoader: true
};

export const mutations = {
  SET_BLOCKING_LOADER(state, status) {
    state.blockingLoader = status;
  },
  SET_NON_BLOCKING_LOADER(state, status) {
    state.nonBlockingLoader = status;
  },
  SET_TABLE_LOADER(state, status) {
    state.tableLoader = status;
  }
};
export const actions = {
  showBlockingLoader({ commit }, status) {
    commit("SET_BLOCKING_LOADER", status);
  },
  showNonBlockingLoader({ commit }, status) {
    commit("SET_NON_BLOCKING_LOADER", status);
  },
  showTableLoader({ commit }, status) {
    commit("SET_TABLE_LOADER", status);
  }
};
